/*
 * FOC-36 · Resumen de retiro en el carrito.
 * Actualiza la línea «Retiro: <día> · <franja>» cuando Pickeasy guarda (o cambia) el día y la
 * franja en los atributos del carrito. El resto del resumen se renderiza en el servidor
 * (snippets/foc-pickup-summary.liquid) y funciona sin JavaScript.
 * Mismas reglas de formato que el Liquid. Sin dependencias.
 */
(function () {
  'use strict';

  var root = typeof window !== 'undefined' ? window : globalThis;

  /**
   * «2026-11-03», «2026/11/03», «03/11/2026», «03-11-2026», y con el mes en texto como lo guarda
   * Pickeasy: «Sat, 24 Oct 2026», «Sat, 24 October 2026», «sáb, 24 oct 2026»
   * → { d, m, weekday (1 = lunes … 7 = domingo) }.
   * Devuelve null si no se reconoce.
   * @param {string} raw
   */
  var MONTHS = {
    jan: 1, ene: 1, feb: 2, mar: 3, apr: 4, abr: 4, may: 5, jun: 6, jul: 7,
    aug: 8, ago: 8, sep: 9, set: 9, oct: 10, nov: 11, dec: 12, dic: 12
  };

  function parseDate(raw) {
    var text = String(raw || '').trim();
    var named = /(\d{1,2})\s+(?:de\s+)?([A-Za-zÀ-ÿ]{3,})\.?,?\s+(?:de\s+)?(\d{4})/.exec(text);
    if (named) {
      var monthKey = named[2].toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').slice(0, 3);
      if (MONTHS[monthKey]) text = named[3] + '-' + MONTHS[monthKey] + '-' + named[1];
    }
    var first = text.split('T')[0].split(' ')[0];
    var parts = first.replace(/\//g, '-').split('-');
    if (parts.length !== 3) return null;
    var y, m, d;
    if (parts[0].length === 4) {
      y = parts[0]; m = parts[1]; d = parts[2];
    } else if (parts[2].length === 4) {
      y = parts[2]; m = parts[1]; d = parts[0];
    } else {
      return null;
    }
    if (!/^\d{4}$/.test(y) || !/^\d{1,2}$/.test(m) || !/^\d{1,2}$/.test(d)) return null;
    var yn = +y, mn = +m, dn = +d;
    if (yn < 2000 || mn < 1 || mn > 12 || dn < 1 || dn > 31) return null;
    var date = new Date(Date.UTC(yn, mn - 1, dn));
    if (date.getUTCMonth() !== mn - 1) return null;
    var weekday = date.getUTCDay() || 7;
    return { d: dn, m: mn, weekday: weekday };
  }

  /**
   * FOC-23 · Franja en 24 h. Misma lógica que snippets/foc-time-range.liquid:
   * «7:00 PM - 8:00 PM», «19:00 - 20:00», «7PM-8PM», «7:00 - 8:00 PM» → ['19', '20'];
   * «10:30-11:30» → ['10:30', '11:30']. Cada extremo se valida por separado (1–12 con AM/PM,
   * 0–23 sin; minutos de 2 dígitos ≤ 59) y el que no trae AM/PM hereda el del otro.
   * Devuelve null si algo no cumple: entonces se muestra el texto original.
   * @param {string} raw
   * @returns {string[] | null}
   */
  function parseTime(raw) {
    var norm = String(raw || '')
      .toLowerCase()
      .replace(/[–—]/g, '-')
      .replace(/ a | to /g, '-')
      .replace(/[\s.]/g, '');
    if (!norm) return null;
    var pieces = norm.split('-');
    if (pieces.length < 1 || pieces.length > 2) return null;
    var ends = [];
    for (var i = 0; i < pieces.length; i++) {
      var match = /^(\d{1,2})(?::(\d{2}))?(am|pm)?(?:hs|h)?$/.exec(pieces[i]);
      if (!match) return null;
      ends.push({ h: +match[1], min: match[2] || '00', suffix: match[3] || '' });
    }
    var inherited = -1;
    if (ends.length === 2) {
      if (!ends[0].suffix && ends[1].suffix) {
        ends[0].suffix = ends[1].suffix;
        inherited = 0;
      } else if (!ends[1].suffix && ends[0].suffix) {
        ends[1].suffix = ends[0].suffix;
        inherited = 1;
      }
    }
    var out = [];
    for (var j = 0; j < ends.length; j++) {
      var end = ends[j];
      var h = end.h;
      if (+end.min > 59) return null;
      if (end.suffix) {
        if (h < 1 || h > 12) return null;
        if (end.suffix === 'pm' && h < 12) h += 12;
        else if (end.suffix === 'am' && h === 12) h = 0;
      } else if (h > 23) {
        return null;
      }
      end.h24 = h;
      out.push(end.min === '00' ? String(h) : h + ':' + end.min);
    }
    // «11:00 - 12:00 PM»: si el sufijo heredado deja el comienzo después del final, era el otro.
    if (inherited !== -1 && ends[0].h24 * 60 + +ends[0].min > ends[1].h24 * 60 + +ends[1].min) {
      var fixed = ends[inherited];
      var h12 = fixed.h % 12;
      var hFixed = fixed.suffix === 'pm' ? h12 : h12 + 12;
      out[inherited] = fixed.min === '00' ? String(hFixed) : hFixed + ':' + fixed.min;
    }
    return out;
  }

  /**
   * @param {string} dateRaw
   * @param {string} timeRaw
   * @param {{ weekdays: string[], slot: string, slotDate: string, hours: string, range: string }} t
   * @returns {string} '' si no hay fecha.
   */
  function formatSlot(dateRaw, timeRaw, t) {
    dateRaw = String(dateRaw || '').trim();
    timeRaw = String(timeRaw || '').trim();
    if (!dateRaw) return '';
    var parsedDate = parseDate(dateRaw);
    var dateText = parsedDate ? t.weekdays[parsedDate.weekday - 1] + ' ' + parsedDate.d + '/' + parsedDate.m : dateRaw;
    if (!timeRaw) return t.slotDate.replace('__FOC_DATE__', dateText);
    var parsedTime = parseTime(timeRaw);
    var timeText = timeRaw;
    if (parsedTime) {
      // El «a» de «19 a 20» sale de locales (foc_cart.time_range), igual que la «h».
      var range =
        parsedTime.length === 2
          ? t.range.replace('__FOC_FROM__', parsedTime[0]).replace('__FOC_TO__', parsedTime[1])
          : parsedTime[0];
      timeText = t.hours.replace('__FOC_TIME__', range);
    }
    return t.slot.replace('__FOC_DATE__', dateText).replace('__FOC_TIME__', timeText);
  }

  var api = { parseDate: parseDate, parseTime: parseTime, formatSlot: formatSlot };
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api;
    return;
  }
  if (typeof document === 'undefined' || !root.fetch || root.focPickupSummaryReady) return;
  // El snippet se renderiza en la página del carrito y en el drawer: una sola instancia.
  root.focPickupSummaryReady = true;

  var timer = null;
  var lastRequest = 0;

  function update() {
    var summaries = document.querySelectorAll('[data-foc-pickup-summary]');
    if (!summaries.length) return;
    var requestId = ++lastRequest;
    var base = (root.Shopify && root.Shopify.routes && root.Shopify.routes.root) || '/';
    root
      .fetch(base + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (cart) {
        if (!cart || requestId !== lastRequest) return;
        var attributes = cart.attributes || {};
        Array.prototype.forEach.call(document.querySelectorAll('[data-foc-pickup-summary]'), function (el) {
          var line = el.querySelector('[data-foc-pickup-slot]');
          if (!line) return;
          // Pickeasy guarda los atributos recién al pasar al checkout: mientras tanto, lo elegido está en
          // los campos de su widget. Si no están (cambió el widget o no cargó), se usan los atributos.
          var widget = findWidget(el);
          var widgetDate = widget && widget.querySelector('#neo-input-date');
          var widgetTime = widget && widget.querySelector('#neo-input-time');
          var chosenDate = widgetDate && widgetDate.value ? widgetDate.value : null;
          var chosenTime = chosenDate && widgetTime ? widgetTime.value : null;
          var dateRaw = chosenDate || attributes[el.dataset.dateAttribute];
          var timeRaw = chosenDate ? chosenTime : attributes[el.dataset.timeAttribute];
          var text = formatSlot(dateRaw, timeRaw, {
            weekdays: (el.dataset.weekdays || '').split(','),
            slot: el.dataset.templateSlot || '__FOC_DATE__ · __FOC_TIME__',
            slotDate: el.dataset.templateSlotDate || '__FOC_DATE__',
            hours: el.dataset.templateHours || '__FOC_TIME__',
            range: el.dataset.templateRange || '__FOC_FROM__–__FOC_TO__'
          });
          // Solo se toca el nodo si cambió, para que el lector de pantalla anuncie únicamente la línea nueva.
          // La región aria-live nunca se oculta (vacía no ocupa lugar), así se anuncia también el primer turno.
          if (line.textContent.trim() !== text) line.textContent = text;
        });
      })
      .catch(function () {
        /* Sin red: queda lo que renderizó el servidor. */
      });
  }

  /**
   * El widget de Pickeasy que acompaña a este resumen: el del carrito lateral para el resumen del
   * carrito lateral, y el de la página para el de la página (puede haber uno en cada lugar).
   * @param {Element} summary
   */
  function findWidget(summary) {
    var drawer = summary.closest('cart-drawer-component');
    if (drawer) return drawer.querySelector('pickeasy-app-widget');
    var widgets = document.querySelectorAll('pickeasy-app-widget');
    for (var i = 0; i < widgets.length; i++) {
      if (!widgets[i].closest('cart-drawer-component')) return widgets[i];
    }
    return null;
  }

  function schedule(delay) {
    clearTimeout(timer);
    timer = setTimeout(update, delay);
  }

  function isCartContext(target) {
    return (
      target instanceof Element &&
      !!target.closest(
        '[data-foc-pickup-summary], .cart__ctas, .cart-totals, cart-drawer-component, .cart-page, pickeasy-app-widget, [id*="pickeasy" i], [class*="pickeasy" i], [class*="neo-"]'
      )
    );
  }

  // Tras elegir día o franja en Pickeasy se relee la selección. En fase de captura: el widget corta la
  // propagación de sus clics (en el carrito lateral no llegaban al document).
  document.addEventListener(
    'change',
    function (event) {
      if (isCartContext(event.target)) schedule(700);
    },
    true
  );
  document.addEventListener(
    'click',
    function (event) {
      if (isCartContext(event.target)) schedule(800);
    },
    true
  );
  document.addEventListener(
    'keyup',
    function (event) {
      if ((event.key === 'Enter' || event.key === ' ') && isCartContext(event.target)) schedule(800);
    },
    true
  );

  [
    'shopify:cart:lines-update',
    'shopify:cart:note-update',
    'shopify:cart:discount-update',
    'shopify:cart:view',
    'cart-section:restored',
    'theme-drawer:open'
  ].forEach(function (name) {
    document.addEventListener(name, function () {
      schedule(400);
    });
  });
})();
